import {Box, CircularProgress} from "@mui/material";
import React from "react";

interface Props {
    fullScreen?: boolean;
}
const LoaderComponent = ({ fullScreen = true }: Props) => {
    return (
        <Box
            sx={{
                width: '100%',
                height: fullScreen ? '100vh' : '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <CircularProgress/>
        </Box>
    );
}

export default LoaderComponent;